module.exports = __webpack_public_path__ + "static/media/wyvern.8639fcb9.png";